import React, {Component} from 'react'

import styled from '@emotion/styled'
import StyleVariales from '../styles/styles'
import AuthBase from '../components/AuthBase'
import AuthButton from '../components/AuthButton'
import AuthFormField from '../components/AuthFormField'
import {alertActions, sourceActions} from "../_actions";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import AuthError from "../components/AuthError";
import {Header} from "../components/Header";
import {AnimatedLoader, Container, IsVerifying, StyledMedia} from "../styles/CommonStyler"
import Footer from "../components/Footer";
import {alertActionTypes} from "../_constants";
import {isMobileOnly} from "react-device-detect";

// STYLE ##########################################################

const sv = StyleVariales;

const Actions = styled(`div`)`
  margin-top: 24px;
  ${sv.flexRow};
`;

const Instructions = styled(`div`)`
  h3 {${sv.h3}}
  ul {
    margin: 8px 0 0 12px;
    list-style-type: disc;
    ${sv.label};
    text-transform: none;
    li {
      margin: 8px 0;
    }
  }
`;

// COMPONENT ##########################################################

class GenerateGist extends Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.verifyLink = this.verifyLink.bind(this);
        this.handleVerify = this.handleVerify.bind(this);
    }

    state = {
        title: '',
        url: '',
    };

    handleChange(e) {
        const {name, value} = e.target;
        this.setState({[name]: value});
    };

    handleVerify(e) {
        e.preventDefault();

        const {t} = this.props;
        const {title, url} = this.state;

        if (title && url) {
            let source = {
                "title": title,
                "probeUri": url
            };

            this.verifyLink(source);
        } else {
            this.props.dispatchEmptyFieldError({"errorMsg": t("Please fill all the fields.")});
        }
    }

    verifyLink(source) {
        this.props.validateLink(source);
    }

    render() {
        const {t, order, alert} = this.props;

        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>

                    <Header/>

                    <AuthBase title={t('Order a Gist.')}>
                        <>
                            {alert.type === alertActionTypes.ERROR &&
                                <AuthError error={alert.message.errorMsg} />
                            }
                            <Instructions>
                                <h3>{t("Please provide a title and file URL")}</h3>
                                <ul>
                                    <li>{t("order_instructions_0")}</li>
                                    <li>{t("order_instructions_1")}</li>
                                    <li>{t("order_instructions_2")}</li>
                                </ul>
                            </Instructions>
                            <AuthFormField
                                label={t("Media title")}
                                placeholder={t('Title of Gist Video or Audio')}
                                name='title'
                                update={this.handleChange}
                            />
                            <AuthFormField
                                label={t("URL of video or audio file")}
                                placeholder='e.g. http://dropbox.com/2847rgd'
                                name='url'
                                update={this.handleChange}
                            />
                            <Actions>
                                {!order.isVerifying &&
                                <AuthButton cancel
                                            onClick={() => this.props.history.goBack()}>{t('Cancel')}</AuthButton>}
                                {!order.isVerifying &&
                                <AuthButton onClick={this.handleVerify}>{t('Verify URL')}</AuthButton>}
                                {order.isVerifying &&
                                <IsVerifying>
                                    <h3>Verifying URL</h3>
                                    <AnimatedLoader color={sv.colors.cta}/>
                                </IsVerifying>
                                }
                            </Actions>
                        </>
                    </AuthBase>
                    <Footer/>
                </Container>
            </StyledMedia>
        )
    }

}

function mapStateToProps(state) {
    const {authentication} = state;
    const {user} = authentication;
    const {alert, order} = state;
    return {
        user, alert, order
    };
}

function mapDispatchToProps(dispatch) {
    return {
        validateLink: (source) => dispatch(sourceActions.validateLink(source)),
        dispatchEmptyFieldError: (msg) => dispatch(alertActions.error(msg))
    };
}

const connectedGenerateGist = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(GenerateGist));
export {connectedGenerateGist as OrderGistUrl};